import { WebshareFetcherOptions } from "@/utils/fetcher";
// eslint-disable-next-line no-restricted-imports
import useSWRInternal, { SWRConfiguration } from "swr";

type WebshareSWROptions =
  | {
      // URL as null is same as disabled
      url: string | null;
      subUserId?: string;
      apiVersion?: "v2" | "v3";
      enabled?: boolean;
    }
  | string
  | null;

/**
 * This is a wrapper around useSWR that adds options that we use in our Webshare API.
 * Such as:
 *  - making a request in name of subuser,
 *  - making a request with a specific API version
 *  - Enabling/disabling the request (instead of x ? x : null checks)
 *
 * The reason this hook exists is so that you are forced to use the correct types that are also supported by our fetcher implementation.
 */
export default function useSWR<TData = unknown, TError = any>(
  // Null is same as disabled
  webshareOptions: WebshareSWROptions,
  swrOptions?: SWRConfiguration<TData, TError>
) {
  const fetcherOptions = getFetcherKey(webshareOptions);

  const isExplicitlyDisabled =
    webshareOptions &&
    typeof webshareOptions === "object" &&
    webshareOptions.enabled === false;

  return useSWRInternal<TData, TError>(
    isExplicitlyDisabled ? null : fetcherOptions,
    swrOptions
  );
}

export function getFetcherKey(options: WebshareSWROptions) {
  let fetcherOptions: WebshareFetcherOptions | null = null;
  if (typeof options === "string") {
    fetcherOptions = {
      url: options,
    };
  } else if (options && options.url) {
    fetcherOptions = {
      url: options.url,
      subUserId: options.subUserId,
      apiVersion: options.apiVersion,
    };
  }
  return fetcherOptions;
}
